<template>
  <div class="mx-auto h-[67vh] w-full max-w-195 overflow-y-auto">
    <section class="mb-3 flex w-full flex-col gap-3">
      <div v-for="{ line: orderline, originalIndex } in computedOrderlines" :key="originalIndex">
        <p class="text-heading-section mb-5">{{ formatOrderlineTitleShort(orderline) }}</p>
        <OrderLineFormDangerousGoods
          v-for="(goods, index2) in orderline.dangerous_goods"
          :key="index2"
          v-model="orderline.dangerous_goods[index2]!"
          @delete-line="removeDangerousGood(index2, originalIndex)"
        />
        <Button class="w-full" :variant="ButtonVariant.Secondary" @click="addDangerousGoods(originalIndex)">
          <Icon src="plus" />
          <p>{{ addDangerousGoodsText }}</p>
        </Button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
  import type { IOrderline } from "~/types/orderline";

  const { formatOrderlineTitleShort, generateDangerousGoods } = useOrderlines();
  const { value: orderLines, validate } = useField<IOrderline[]>(() => "order_lines", undefined, {
    syncVModel: true,
  });

  watch(orderLines, () => validate(), { deep: true });
  const { t } = useI18n();
  const computedOrderlines = computed(() => {
    return (
      orderLines.value
        ?.map((line, originalIndex) => ({ line, originalIndex }))
        .filter(({ line }) => line.dangerous_goods_set) ?? []
    );
  });

  const removeDangerousGood = (dangerousGoodIndex: number, orderLineIndex: number) => {
    orderLines.value?.[orderLineIndex].dangerous_goods?.splice(dangerousGoodIndex, 1);
  };
  const addDangerousGoodsText = computed(() => {
    return t("add_another_entity", {
      entity: t("order_lines.dangerous_goods_item").toLowerCase(),
    });
  });
  const addDangerousGoods = (index: number) => {
    if (!orderLines.value?.[index]) return;

    const dangerousGood = generateDangerousGoods();

    if (!orderLines.value[index].dangerous_goods) {
      orderLines.value[index].dangerous_goods = [];
    }

    orderLines.value[index].dangerous_goods_set = true;
    orderLines.value[index].dangerous_goods.push(dangerousGood);
  };
</script>
